if(!customElements.get('faq-tabs')) {
  class faqTabs extends HTMLElement {
    constructor() {
      super();
      this.triggers             = this.querySelectorAll('a');
      this.allQuestions         = document.querySelectorAll('.accordion-section-faq');
      this.searchHeader         = document.querySelector('.section-faq-inner__header');
      this.hero                 = document.querySelector('.hero-faq');
      this.heroTitle            = document.querySelector('.hero-faq__title');
      this.accordions           = document.querySelector('.section-faq-inner__content');
    }

    filterTabs(that) {
      event.preventDefault();

      this.searchHeader.classList.add('hidden');
      this.hero.classList.add('title-only')
      this.heroTitle.textContent = that.textContent

      this.triggers.forEach(trigger => {
        trigger.closest('li').classList.remove('current');
      });

      that.closest('li').classList.add('current');
      const category = that.dataset.category

      this.allQuestions.forEach(question => {
        question.classList.contains(category) ? question.style.display = 'block' : question.style.display = 'none'
      });
    }

    connectedCallback() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {

          this.filterTabs(trigger);

          const windowWidth = window.innerWidth

          if (windowWidth < 767) {
            scrollToElement(document.body, this.accordions.offsetTop - 100);
            this.accordions.style.display = 'block'
          };
        });
      });
    }
  }

  customElements.define('faq-tabs', faqTabs);
}


function scrollToElement(element, to) {
  scroll({
    top: to,
    behavior: "smooth"
  });
}
